module.exports = __webpack_public_path__ + "static/media/linkedin.a563ed08.svg";